/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NewsHighlightsComponentEditor } from "cms/components/components/news-highlights/edit";
import { NewsHighlightsComponentDisplay } from "cms/components/components/news-highlights/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const NewsHighlightsComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NewsHighlightsComponentDisplay />,
        editComponent: <NewsHighlightsComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

NewsHighlightsComponent.displayName = "NewsHighlightsComponent";
export { NewsHighlightsComponent };

